export class ListItemModel {
  id: any;
  text: string;
  obj: any;

  constructor(id: any, text: string, obj: any) {
    this.id = id;
    this.text = text;
    this.obj = obj;
  }
}



// WEBPACK FOOTER //
// ./src/app/component/select-custom/list.item.model.ts